import React, { useState } from 'react'
import uuid from 'react-uuid'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

type Props = {
  checkinId: string
  identifications: any
  hotelId: string
  onClickDeleteImage: (string) => void
  onAddImage?: (file: { file: File; previewUrl: string; tempId: string }) => void
}

export const Identification: React.FC<Props> = ({ checkinId, identifications, hotelId, onClickDeleteImage, onAddImage }) => {
  const { t } = useTranslation()
  const [previewImageUrl, setPreviewImageUrl] = useState<string | undefined>(undefined)

  const handleAddFile = (e: any) => {
    const files = e.target.files
    if (files.length > 0) {
      const file = files[0]
      const previewUrl = URL.createObjectURL(file)
      onAddImage?.({ file, previewUrl, tempId: uuid() })
    } else {
      console.log(t('Upload failed'))
    }
  }

  return (
    <>
      <div>
        <div css={wrapperStyle}>
          <div css={imageListStyle}>
            {(identifications || []).map(v => (
              <div key={v.identificationId || v.tempId}>
                <img
                  onClick={() => onClickDeleteImage(v.identificationId || v.tempId)}
                  src={require('@/static/images/deleat_icon.svg')}
                  css={identificationImageDeleteButtonStyle}
                />
                <img
                  onClick={() => {
                    setPreviewImageUrl(v.previewUrl || v.imageKey)
                  }}
                  src={v.previewUrl || v.imageKey}
                  css={identificationImageStyle}
                />
              </div>
            ))}
            <div css={imageNotListStyle}></div>
            <label htmlFor="identificationNumber" css={addIdentificationContainerStyle}>
              <img src={require('@/static/images/plus.svg')} />
              <p>{t('Add ID')}</p>
            </label>
            <input
              type="file"
              id="identificationNumber"
              css={inputNoneStyle}
              onChange={e => handleAddFile(e)}
              onClick={(e: any) => {
                e.target.value = ''
              }}
            />
          </div>
        </div>
      </div>
      {previewImageUrl && (
        <div onClick={() => setPreviewImageUrl(undefined)} css={modalOverlayStyle}>
          <img src={previewImageUrl} />
        </div>
      )}
    </>
  )
}

const wrapperStyle = css({
  margin: '9px 32px 16px 16px',
  position: 'relative',
  justifyContent: 'left',
  fontSize: 12,
  color: '#676767',
})

// 身分証を追加
const addIdentificationContainerStyle = css({
  cursor: 'pointer',
  display: 'flex',
  height: 96,
  width: 375,
  backgroundColor: '#FFF',
  justifyContent: 'center',
  border: '1px dashed #CCCCCC',
  borderRadius: 6,
  p: {
    color: '#F2A40B',
    fontSize: 14,
    fontWeight: 'bold',
  },
  alignItems: 'center',
})

const inputNoneStyle = css({
  display: 'none',
})

const imageListStyle = css({
  alignItems: 'center',
})

const imageNotListStyle = css({
  marginTop: '24px',
})

const identificationImageStyle = css({
  maxWidth: 375,
  borderRadius: 6,
  marginTop: 15,
  marginRight: 10,
  marginBottom: 16,
  cursor: 'pointer',
})

const identificationImageDeleteButtonStyle = css({
  position: 'absolute',
  right: 0,
  height: 30,
  borderRadius: '50%',
  background: '#ffffff',
  '&:hover': {
    cursor: 'pointer',
  },
})

const modalOverlayStyle = css({
  position: 'fixed',
  background: 'rgba(39, 39, 39, 0.5)',
  width: '100vw',
  height: '100vh',
  top: 0,
  left: 0,
  zIndex: 10000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  '>img': {
    maxWidth: '70vw',
    maxHeight: '70vh',
    objectFit: 'contain',
  },
})
